import React from 'react';
import { Outlet } from 'react-router-dom';

const ExecutiveContent = () => {
  return <Outlet />;
};

export default ExecutiveContent;
